import "./bannerForm.css";
import { useState } from 'react';
import { useCreateBannerMutation } from '../../services/bannerApi'
import { useNavigate } from "react-router-dom";
import { AdminPageHeader, AdminCard, AdminInput, FieldError, LoadingButton, useToast } from '../../components/ui'

const NewBanner = () => {
  const navigate = useNavigate();
  const [server_error, setServerError] = useState({})
  const [createBanner, { isLoading }] = useCreateBannerMutation()
  const toast = useToast();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    formData.set('is_active', formData.get('is_active') ? 'true' : 'false');

    const res = await createBanner(formData);
    if (res.error) {
      setServerError(res.error.data?.errors || {});
      toast.error("Could not create this banner. Check the fields below.");
    }
    if (res.data) {
      toast.success("Banner added successfully.");
      setTimeout(() => navigate('/admin/banners'), 1200);
    }
  };

  return (
    <div>
      <AdminPageHeader
        title="New Banner"
        breadcrumbs={[{ label: "Dashboard", to: "/admin/dashboard" }, { label: "Banners", to: "/admin/banners" }, { label: "New" }]}
      />
      <AdminCard className="bannerForm">
        <form onSubmit={handleSubmit}>
          <div className="admin-field">
            <label className="admin-field__label" htmlFor="image">Image</label>
            <input id="image" type="file" name="image" accept="image/*" required />
            <FieldError>{server_error.image?.[0]}</FieldError>
          </div>
          <AdminInput label="Title (optional)" name="title" placeholder="e.g. Diwali Sale" />
          <AdminInput label="Subtitle (optional)" name="subtitle" placeholder="e.g. 20% off all ingredients" />
          <AdminInput label="Link URL (optional)" name="link_url" placeholder="/shop" />
          <AdminInput label="Sort Order" type="number" name="sort_order" defaultValue={0} />
          <AdminInput label="Starts At (optional)" type="datetime-local" name="starts_at" />
          <AdminInput label="Ends At (optional)" type="datetime-local" name="ends_at" />
          <label className="bannerForm__checkbox">
            <input type="checkbox" name="is_active" defaultChecked /> Active
          </label>
          <div className="bannerForm__actions">
            <LoadingButton type="submit" loading={isLoading} loadingLabel="Creating...">Create Banner</LoadingButton>
          </div>
        </form>
      </AdminCard>
    </div>
  );
}

export default NewBanner
